import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';
import { ILocalization } from 'bernie-l10n';

import { PropertyAlternativeNameModel } from 'src/common/models/hotel/hotel-details-types';
import { PropertyInfoSectionViewModel, PropertyInfoSubSectionViewModel } from 'models';

import { UitkHeading } from 'uitk-react-text';
import { UitkLink } from 'uitk-react-link';

import { renderAlternativeNames, renderAmenityBody } from './render-amenity-helper';

interface ImportantInfoProps {
  analytics?: AnalyticsStore;
  importantInfo?: PropertyInfoSectionViewModel;
  l10n: ILocalization;
  shouldMention?: PropertyInfoSubSectionViewModel;
  propertyAKA?: PropertyAlternativeNameModel;
  hrefNextPage?: string;
}

export const ImportantInfo: React.FunctionComponent<ImportantInfoProps> = ({
  importantInfo,
  l10n,
  shouldMention,
  propertyAKA,
  hrefNextPage
}) => {
  if (!(importantInfo && importantInfo.title)) {
    return null;
  }

  return (
    <div className="uitk-grid s-x-padding-three m-x-padding-three l-x-padding-six xl-x-padding-six all-t-padding-three">
      <div className="uitk-cell s-cell-1-1 l-cell-1-3 xl-cell-1-3 all-y-padding-three">
        <UitkHeading level={2} size={600}>
          {importantInfo.title}
        </UitkHeading>
      </div>
      <div className="uitk-cell l-cell-2-3 xl-cell-2-3">
        <ImportantInfoContent importantInfo={importantInfo} />
        <ShouldMention shouldMention={shouldMention} />
        <PropertyAKA propertyAKA={propertyAKA} />
        <HrefNextPage hrefNextPage={hrefNextPage} formatText={l10n.formatText} />
      </div>
    </div>
  );
};

export const ImportantInfoContent = ({ importantInfo }) => {
  if (!(importantInfo && importantInfo.sections && importantInfo.sections.length > 0)) {
    return null;
  }

  return (
    <>
      {importantInfo.sections.map((section, index) => (
        <>
          {section &&
            section.body &&
            section.body.length > 0 && (
              <div className="policies__section--text all-y-padding-three">
                <h3 className="policies__header--secondary uitk-type-heading-500 uitk-type-bold" key={`important-info-title-${index}`}>
                  {section.title}
                </h3>
                <div className="all-t-padding-two">
                  {section.body.map((text, bodyIndex) => (
                    <div
                      className="policies__body uitk-type-list-300"
                      dangerouslySetInnerHTML={{ __html: text }}
                      key={`important-info-list-item-${bodyIndex}`}
                    />
                  ))}
                </div>
              </div>
            )}
        </>
      ))}
    </>
  );
};

export const ShouldMention = ({ shouldMention }) => {
  if (!(shouldMention && shouldMention.title && shouldMention.body && shouldMention.body.length > 0)) {
    return null;
  }

  return (
    <div className="info-should-mention policies__section--text all-y-padding-three">
      <h3 className="info-should-mention__section__title uitk-type-heading-500 uitk-type-bold">{shouldMention.title}</h3>
      <div className="all-t-padding-two">{shouldMention.body.map((text, index) => renderAmenityBody(text, index, 'should-mention'))}</div>
    </div>
  );
};

export const PropertyAKA = ({ propertyAKA }) => {
  if (!(propertyAKA && propertyAKA.sections && propertyAKA.sections.length > 0)) {
    return null;
  }

  return (
    <div className="info-property-alternative-name policies__section--text all-y-padding-three">
      <h3 className="info-property-alternative-name__section__title uitk-type-heading-500 uitk-type-bold">{propertyAKA.title}</h3>
      <div className="policies__body uitk-type-list-300 info-important__section__body all-t-padding-two">
        <ul>{propertyAKA.sections.map(section => renderAlternativeNames(section))}</ul>
      </div>
    </div>
  );
};

export const HrefNextPage = ({ hrefNextPage, formatText }) => {
  if (!hrefNextPage || !formatText) {
    return null;
  }

  return (
    <UitkLink>
      <a href={hrefNextPage} className="uitk-cell all-y-padding-three" target="_blank">
        {formatText('hotels.infosite.policies.allReviews')}
      </a>
    </UitkLink>
  );
};
